(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  var HOVER_VOLUME = 0.12;
  var CLICK_VOLUME = 0.18;
  var HOVER_THROTTLE_MS = 80;

  // Ducking hook for eva-radio.js (and anything else that plays real
  // audio over the top of these UI blips): multiplies hover/click
  // volume by this factor, restored to 1 on stop/pause. Deliberately
  // NOT tied to evaSoundMuted -- ducking is "quieter while something
  // else plays", muting is "off entirely", two different concerns.
  var duckFactor = 1;
  window.EvaSoundEngine = {
    duck: function (factor) { duckFactor = factor; },
    restore: function () { duckFactor = 1; }
  };

  // Icon row, top-level + dropdown desktop nav, mobile slide-nav, and the
  // day/night mode toggle -- every interactive header/menu element per spec.
  // The new sound-mute button itself is picked up here too (it's just
  // another .site-nav__link--icon sibling in the row), so toggling it gets
  // the same click-confirmation sound as everything else, gated on
  // whatever the mute state is AFTER this same click already flipped it
  // (that button's own listener runs before this delegated one, since it's
  // bound directly on the element and fires first on the way to document).
  //
  // This whole file only EVER wires sound this one way -- one delegated
  // listener on document, matched by CSS class via .closest(). There is
  // no per-element/per-menu-item hook anywhere (confirmed: assets/mega-
  // menu.js has zero sound-related code) -- an item gets sound purely by
  // carrying one of the classes listed here, nothing else.
  //
  // .mega-menu__rail-item (2026-08-04) -- the desktop SHOP ALL rail
  // (snippets/header-desktop-nav.liquid: Skateboards/Apparel/Wheels/
  // Trucks/Hardware/Accessories/Stuff/Brands) was missing entirely from
  // this list, for every single item, not just the ones restored 2 Aug --
  // Hardware/Accessories/Stuff being silent was a symptom of the whole
  // rail never having been wired up, not those three items missing an
  // individual hook. Targeting the shared .mega-menu__rail-item class
  // (every <li> in the rail, including "Brands" which has no <a> of its
  // own -- the <li> itself is the click target there) rather than
  // .mega-menu__rail-link means any future rail item gets sound for
  // free just by using the existing markup pattern, with no separate
  // wiring step to remember.
  var SOUND_TARGETS =
    '.site-nav__link, .site-nav__dropdown-link, .slide-nav__link, ' +
    '.slide-nav__sublist-link, .slide-nav__return-btn, .mega-menu__rail-item, ' +
    '[data-mode-toggle]';

  function playSound(audio, volume) {
    if (!audio || (window.EvaMute && window.EvaMute.isMuted())) { return; }
    // (c) 2026-08-27, Per: THE SITE MAKES NO SOUND UNTIL MUSIC HAS
    // ACTUALLY STARTED THIS VISIT. On iOS a page cannot mix with another
    // app's audio, so a single UI blip takes over the phone's audio
    // session and stops Spotify -- from a visitor who only came to look
    // at decks and never asked this site for a sound.
    //
    // Gated HERE, in the one choke point both the hover and the click
    // blip funnel through, rather than at the two call sites: a hover
    // blip seizes the session exactly as a click one does, so gating
    // only clicks would leave the hole open on desktop.
    //
    // NOT the `armed` flag below -- that is an autoplay-policy flag that
    // flips on the first pointerdown ANYWHERE, which is precisely the
    // "any tap counts" behaviour this rule exists to stop. The real
    // signal is EvaAudioPolicy.hasMusicStarted(), set only by the tape
    // element's own 'play' event and a genuine station tune attempt.
    //
    // ONE RULE, touch and desktop alike -- no platform split, per Per.
    if (window.EvaAudioPolicy && !window.EvaAudioPolicy.hasMusicStarted()) { return; }
    try {
      // Explicit pause before rewinding: hover fires often enough while
      // sweeping the menu that just seeking currentTime on a still-playing
      // instance isn't reliably enough to stop its tail before restarting
      // -- pause() first guarantees a clean cut, not an overlap, even
      // mid-decode.
      audio.pause();
      audio.currentTime = 0;
      audio.volume = volume;
      var p = audio.play();
      // Autoplay/gesture policies can still reject an individual play()
      // call even after arming (e.g. mid-decode) -- swallow it, no
      // console noise, just no sound that one time.
      if (p && typeof p.catch === 'function') { p.catch(function () {}); }
    } catch (e) {}
  }

  // Asset URLs come from window.EvaSoundAssets, a tiny inline Liquid-rendered
  // script in layout/theme.liquid (this file is a plain .js asset -- Shopify
  // doesn't process Liquid tags in it, so the URLs can't be built here).
  var ASSETS = window.EvaSoundAssets || {};

  var hoverAudio = null;
  var clickAudio = null;
  // ui-click.mp3 (the longer/textured one) is retired from this engine --
  // click now reuses the same short tick as hover (ui-hover.mp3), just
  // louder, rather than a separate sound. Two independent Audio
  // instances of the same file (not one shared instance) so a click
  // firing right after a hover doesn't cut the other's tail short.
  // ui-click.mp3 itself stays in assets -- eva-radio.js's RECORD
  // hotspot still uses it directly via window.EvaSoundAssets.click.
  try {
    if (ASSETS.hover) {
      hoverAudio = new Audio(ASSETS.hover);
      hoverAudio.preload = 'auto';
    }
  } catch (e) {}
  try {
    if (ASSETS.hover) {
      clickAudio = new Audio(ASSETS.hover);
      clickAudio.preload = 'auto';
    }
  } catch (e) {}

  var lastHoverTime = 0;
  // The resolved (closest-ancestor) element currently under the pointer --
  // NOT e.target directly. pointerenter is non-bubbling, but delegating it
  // via document's capture phase still catches a separate enter for every
  // nested descendant (svg/img/span) the cursor crosses, each with its own
  // target, even while the pointer never left the outer button's box. Only
  // reacting when the RESOLVED ancestor changes (including changing to/
  // from null, so leaving to blank page background and re-entering the
  // same button later still counts as fresh) is what keeps moving between
  // a button's own children silent.
  var currentHoverEl = null;

  // Browsers block audio.play() before any real gesture on the document.
  // Arm on the first pointerdown/keydown/touchstart anywhere; hover sounds
  // that happen to fire before that (mouse already over a link on load)
  // are silently skipped, not queued.
  var armed = false;
  function arm() {
    if (armed) { return; }
    armed = true;
    document.removeEventListener('pointerdown', arm, true);
    document.removeEventListener('keydown', arm, true);
    document.removeEventListener('touchstart', arm, true);
  }
  document.addEventListener('pointerdown', arm, true);
  document.addEventListener('keydown', arm, true);
  document.addEventListener('touchstart', arm, true);

  // pointerenter doesn't bubble, so delegation needs the capture phase --
  // it still reaches document for every element regardless of event type.
  document.addEventListener(
    'pointerenter',
    function (e) {
      if (!armed) { return; }
      if (e.pointerType !== 'mouse') { return; } // desktop-only, skip touch (and pen)
      var el = e.target.closest && e.target.closest(SOUND_TARGETS);
      if (el === currentHoverEl) { return; } // same resolved element -- moved between its own descendants, stay silent
      currentHoverEl = el;
      if (!el) { return; }
      var now = Date.now();
      if (now - lastHoverTime < HOVER_THROTTLE_MS) { return; }
      lastHoverTime = now;
      playSound(hoverAudio, HOVER_VOLUME * duckFactor);
    },
    true
  );

  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest(SOUND_TARGETS);
    if (!el) { return; }
    // HARD RULE (Per, 2026-08-26): the mute toggle NEVER makes a sound,
    // in either direction. It carries .site-nav__link (see
    // snippets/header-icon-corners.liquid), so it matched SOUND_TARGETS
    // and got the shared click blip like any other icon -- this file's
    // own comment above described that as intended behaviour.
    //
    // It was only ever half-silent, and the wrong half. The button's own
    // listener is bound directly on the element, so it runs BEFORE this
    // delegated one and has already flipped the flag by now: muting
    // leaves isMuted() true and playSound() bails, but UNMUTING leaves
    // it false, so turning sound back on played a blip. On iOS that blip
    // is a real audio start, which takes over the phone's audio session
    // and stops whatever else was playing.
    if (e.target.closest('.js-sound-mute-toggle')) { return; }
    playSound(clickAudio, CLICK_VOLUME * duckFactor);
  });

  // --- Global mute toggle ---------------------------------------------

  function updateMuteButtonUI(btn) {
    var muted = window.EvaMute ? window.EvaMute.isMuted() : false;
    var img = btn.querySelector('img');
    btn.setAttribute('aria-pressed', muted ? 'true' : 'false');
    if (img) {
      img.src = muted ? img.getAttribute('data-icon-off') : img.getAttribute('data-icon-on');
    }
  }

  ready(function () {
    // header-icon-stack.liquid renders this row twice (once per
    // breakpoint, one hidden via CSS at a time -- same pattern every
    // other icon in the row already uses), so there are two buttons in
    // the DOM. Wire up both and keep them in sync with each other so a
    // resize across the breakpoint never shows a stale icon.
    var muteBtns = document.querySelectorAll('.js-sound-mute-toggle');
    if (!muteBtns.length) { return; }

    // aria-pressed/icon start matching the default (unmuted) in markup;
    // correct to whatever's actually in localStorage before the user
    // sees a flash of the wrong icon.
    muteBtns.forEach(updateMuteButtonUI);

    muteBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (window.EvaMute) { window.EvaMute.setMuted(!window.EvaMute.isMuted()); }
      });
    });

    // Two-way sync: the Källare OSD mute control (and anything else
    // that calls EvaMute.setMuted) shares this exact event, so the
    // header icon reflects a change made anywhere, not just its own
    // click -- same listener drives both the click-triggered case and
    // any other source.
    document.addEventListener(window.EvaMute ? window.EvaMute.EVENT : 'eva:sound:muted', function () {
      muteBtns.forEach(updateMuteButtonUI);
    });
  });
})();
